<template>
    <div>
        <v-skeleton-loader v-show="cargando" v-for="i in [0,1]" type="list-item" :key="`b-${i}`">
        </v-skeleton-loader>

        <v-list v-show="!cargando">
            <v-list-item v-for="(itm,i) in items" :key="i" @click="seleccionar(itm)"
                         :class="{'secondary':(itm == null && seleccionadoId == null) ||
                         (itm != null && itm[propiedad] === seleccionadoId)}">
                <v-list-item-content>
                    <v-list-item-title>
                        <div v-if="itm == null">{{ $t('no') | capitalize }}</div>
                        <div v-if="itm != null">
                            {{ itm[nombre] }}
                            <v-tooltip v-if="descripcion" bottom class="pl-2" max-width="500">
                                <template v-slot:activator="{on}">
                                    <v-icon v-on="on">mdi-information-outline</v-icon>
                                </template>
                                <span>{{ itm[descripcion] }}</span>
                            </v-tooltip>
                        </div>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
    export default {
        name: "SeleccionComponenteSC",
        model: {
            prop: 'seleccionado',
            event: 'change'
        },
        props: {
            seleccionado: {type: Object, default: null},
            items: {required: true, type: Array},
            propiedad: {required: true, type: String},
            nombre: {required: true, type: String},
            descripcion: {type: [String, null], default: null},
            cargando: {type: Boolean, default: false}
        },
        watch: {
            seleccionado: {
                handler() {
                    this.seleccionaSiSoloHayUnaOpcion();
                },
            },
            items: {
                handler() {
                    this.seleccionaSiSoloHayUnaOpcion();
                },
                deep: true
            }
        },
        computed: {
            seleccionadoId() {
                if (this.seleccionado == null) return null;
                return this.seleccionado[this.propiedad];
            }
        },
        methods: {
            seleccionar(item) {
                this.$emit("change", item);
            },
            seleccionaSiSoloHayUnaOpcion() {
                if (this.seleccionado == null && this.items.length === 1) {
                    this.seleccionar(this.items[0]);
                }
            },
        }
    }
</script>

<style scoped>

</style>